import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=b628cf60&scoped=true"
import script from "./ClockIcon.vue?vue&type=script&lang=js"
export * from "./ClockIcon.vue?vue&type=script&lang=js"
import style0 from "./ClockIcon.vue?vue&type=style&index=0&id=b628cf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b628cf60",
  null
  
)

export default component.exports